import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RewardList from "../../components/RewardList";

const RewardListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Rewards Transactions" />

        <RewardList />
      </MasterLayout>
    </>
  );
};

export default RewardListPage;
